import { useNavigate } from "react-router-dom";
import { useApi } from "../useApi.js";
import { euro, dateDe } from "../api.js";
import type { Dashboard as D } from "../types.js";
import { Page, Pill } from "../components/Shell.js";

export default function Dashboard() {
  const nav = useNavigate();
  const { data, error, loading } = useApi<D>("/api/dashboard");

  if (loading) return <Page title="Übersicht"><div className="empty">Wird geladen…</div></Page>;
  if (error || !data) return <Page title="Übersicht"><div className="empty">{error}</div></Page>;

  return (
    <Page title="Übersicht"
          sub={`${data.devices.total} Geräte · Stand ${dateDe(new Date())}`}>
      <div className="grid" style={{ gap: 20 }}>
        <div className="kpis">
          <button className={`kpi ${data.devices.critical ? "is-crit" : ""}`} onClick={() => nav("/geraete?f=CRITICAL")}>
            <span className="v">{data.devices.critical}</span>
            <span className="l">Geräte mit Handlungsbedarf</span>
            <span className="m">Intervall überschritten oder Prüfung überfällig</span>
          </button>
          <button className={`kpi ${data.devices.warning ? "is-warn" : ""}`} onClick={() => nav("/geraete?f=WARNING")}>
            <span className="v">{data.devices.warning}</span>
            <span className="l">Geräte zu beobachten</span>
            <span className="m">Teilewechsel in den nächsten 30 Tagen</span>
          </button>
          <button className="kpi is-ok" onClick={() => nav("/geraete?f=OK")}>
            <span className="v">{data.devices.ok}</span>
            <span className="l">Einsatzbereit</span><span className="m">Keine offenen Punkte</span>
          </button>
          <button className="kpi" onClick={() => nav("/service")}>
            <span className="v">{data.openTickets}</span>
            <span className="l">Offene Serviceaufträge</span>
          </button>
          <button className={`kpi ${data.parts.critical ? "is-crit" : ""}`} onClick={() => nav("/ersatzteile")}>
            <span className="v">{data.parts.critical}</span>
            <span className="l">Artikel unter Mindestbestand</span>
            <span className="m">Vorschlagswert {euro(data.parts.suggestionValueCents)}</span>
          </button>
        </div>

        <div className="grid g2">
          <div className="card">
            <div className="card-h">
              <h3>Handlungsbedarf</h3>
              <span className="hint">aus Verschleißzählern, Prüffristen und Protokollübernahme</span>
            </div>
            <div className="tbl-wrap">
              {data.actions.length === 0
                ? <div className="empty">Keine offenen Punkte.</div>
                : <table><tbody>
                    {data.actions.map((a, i) => (
                      <tr key={i} className="click" onClick={() => nav(`/geraete/${a.deviceId}`)}>
                        <td style={{ width: "1%" }}>
                          <Pill status={a.status}>{a.status === "CRITICAL" ? "Kritisch" : "Achtung"}</Pill>
                        </td>
                        <td><b className="mono">{a.inventoryNo}</b> <span className="sub-t">{a.crew}</span></td>
                        <td>{a.text}</td>
                      </tr>
                    ))}
                  </tbody></table>}
            </div>
          </div>

          <div className="card">
            <div className="card-h"><h3>Prüffristen DGUV V3 / UVV</h3><span className="hint">nächste 30 Tage</span></div>
            <div className="tbl-wrap">
              {data.inspections.length === 0
                ? <div className="empty">Keine Fristen in den nächsten 30 Tagen.</div>
                : <table><tbody>
                    {data.inspections.map((d) => (
                      <tr key={d.id} className="click" onClick={() => nav(`/geraete/${d.id}`)}>
                        <td><b className="mono">{d.inventoryNo}</b><div className="sub-t">{d.location}</div></td>
                        <td className="num">{dateDe(d.nextInspectionAt)}</td>
                        <td className="r">
                          {d.daysToInspection < 0
                            ? <Pill status="CRITICAL">{Math.abs(d.daysToInspection)} T überfällig</Pill>
                            : <Pill status={d.daysToInspection <= 14 ? "WARNING" : "mute"}>in {d.daysToInspection} T</Pill>}
                        </td>
                      </tr>
                    ))}
                  </tbody></table>}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}
